// @file: src/pages/scales/FireFightingUnit.js
// Componente de unidade de combate a incêndio da escala da TV (UCI / combatentes)

import { Container } from "./styles";

const FireFightingUnit = ({ scale, title, type }) => {
  // Garante que sempre temos um array, mesmo se vier null/undefined da API
  const fighters =
    scale && Array.isArray(scale.fighters_scales) ? scale.fighters_scales : [];

  // Evita quebrar a tela se scale vier null/undefined
  if (!scale) {
    return null;
  }

  return (
    <Container>
      <h5 className="uci-title">
        {title} {scale.vehicle?.number}
      </h5>

      {type !== "uci1" ? (
        <div className="px-2">
          <h6>MOTORISTA</h6>
          <p>{fighters[0]?.fighter?.nickname}</p>

          <h6>{type}</h6>

          <p>{fighters[1]?.fighter?.nickname}</p>

          <p>{fighters[2]?.fighter?.nickname}</p>

          <p>{fighters[3]?.fighter?.nickname}</p>

          <p>{fighters[4]?.fighter?.nickname}</p>

          <p>{fighters[5]?.fighter?.nickname}</p>
        </div>
      ) : (
        <div className="px-2">
          <div>
            <h6 className="me-1">MOTORISTA</h6>
            <p>{fighters[0]?.fighter?.nickname}</p>
          </div>

          <h6>COMBATENTES</h6>

          <div className="d-flex">
            <h6 className="me-1 uci-h6">RAP</h6>
            <p>{fighters[1]?.fighter?.nickname}</p>
          </div>

          <div className="d-flex">
            <h6 className="me-1 uci-h6">EPR</h6>
            <p>{fighters[2]?.fighter?.nickname}</p>
          </div>

          <div className="d-flex">
            <h6 className="me-1 uci-h6">EPR</h6>
            <p>{fighters[3]?.fighter?.nickname}</p>
          </div>

          <div className="d-flex">
            <h6 className="me-1 uci-h6">COM</h6>
            <p>{fighters[4]?.fighter?.nickname}</p>
          </div>

          <div className="d-flex">
            <h6 className="me-1 uci-h6">COM</h6>
            <p>{fighters[5]?.fighter?.nickname}</p>
          </div>
        </div>
      )}
    </Container>
  );
};

export default FireFightingUnit;
